// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","button":"Navbar_button__wnv69"};